const social = [
  { 
    name: 'Twitter',
    link: 'http://twitter.com/johnm__/'
  },{
    name: 'Dribbble',
    link: 'http://dribbble.com/johnm__/'
  },{
    name: 'Github',
    link: 'http://github.com/johnpmorris'
  },{
    name: 'Codepen',
    link: 'http://codepen.com/johnm__/'
  },{
    name: 'Instagram',
    link: 'http://instagram.com/johnm__/'
  },{
    name: 'Email Spam',
    link: 'http://www.linkedin.com/in/johnphilipmorris'
  }];

export default social;



/** WEBPACK FOOTER **
 ** ../consts/social.js
 **/